import { User } from "@/lib/types";
import { OwnerDashboard } from "./OwnerDashboard";
import { AgentDashboard } from "./AgentDashboard";
import { GuestDashboard } from "./GuestDashboard";

interface DashboardContentProps {
  user: User;
}

export function DashboardContent({ user }: DashboardContentProps) {
  // Determine which dashboard to render based on user role
  const renderDashboard = () => {
    const role = user.role.toLowerCase();
    
    if (role === "owner" || role === "manager") {
      return <OwnerDashboard user={user} />;
    } else if (role === "agent") {
      return <AgentDashboard user={user} />;
    } else if (role === "admin") {
      // You could add an AdminDashboard here or just use OwnerDashboard as a fallback
      return <OwnerDashboard user={user} />;
    } else {
      // Default to guest dashboard for any other role
      return <GuestDashboard user={user} />;
    }
  };

  return renderDashboard();
}